export default "__VITE_ASSET__C49DQwzz__"